module.exports = __webpack_public_path__ + "img/wa-hover-en.e4fdfe1a.png";